<template>
  <div class="thumbnail" v-if="total.url">
    <van-popup v-model="pdfShow">
      <div class="pdf" id="pdf"></div>
    </van-popup>
    <img v-if="DelIcon" @click="removePdf" src="../assets/images/removeImg.svg" class="remove-img" />
    <div @click.stop="PDFthumbnail" class="thumbnail_top">
      <img class="thumbnail_top_icon" src="../assets/images/icon_pdf.png">
    </div>
    <div @click.stop="PDFthumbnail" class="thumbnail_bottom">
      <div class="pdf_name" ref="element">{{showTotal.name}}</div>
      <img class="thumbnail_bottom_icon" src="../assets/images/icon_pdf_ring.svg">
    </div>
  </div>
  <div class="thumbnail" @click.stop="startPdf" v-else-if="index < 10">
    <img class="add_icon" src="../assets/images/add.png">
    <input @change="uploadFile" ref="upText" style="display: none;" accept="application/pdf" type="file" />
  </div>
</template>

<script>
import Pdfh5 from 'pdfh5'
import 'pdfh5/css/pdfh5.css'
export default {
  props: {
    total: {
      type: Object
    },
    index: {
      type: Number
    },
    DelIcon: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showTotal: {},
      pdfh5: null,
      pdfShow: false,
      numPages: 0
    }
  },
  mounted () {
    this.totalComputed()
  },
  methods: {
    PDFthumbnail () {
      this.pdfShow = !this.pdfShow
      this.$nextTick(() => {
        this.loadPdf()
      })
    },
    loadPdf () {
      // 实例化
      this.pdfh5 = new Pdfh5('#pdf', {
        pdfurl: this.showTotal.url,
        URIenable: true, // true开启地址栏file参数
        // renderType: 'svg', // pdf渲染模式 svg canvas
        lazy: true, // 是否开启懒加载
        // maxZoom: 3, // 手势缩放最大倍数 默认3
        // scrollEnable: true, // 是否允许pdf滚动
        zoomEnable: true, // 是否允许pdf手势缩放
        goto: 1
      })
      // 监听完成事件
      // this.pdfh5.on('complete', (status, msg, time) => {
      //   console.log('状态：', status, ', 信息：', msg, ', 耗时：', time, '毫秒，总页数：', this.totalNum)
      // })
      // // pdf 监听加载失败，msg信息，time耗时
      this.pdfh5.on('error', (msg, time) => {
        // console.log('pdf加载失败', '信息：', msg, ', 耗时：', time, '毫秒')
      })
    },
    fntest () {
      this.show = true
      // console.log(this.show)
    },
    totalComputed () {
      if (!this.total.name) {
        this.showTotal = { ...this.total, name: `${this.extractString(this.total.url)}.pdf` }
      } else {
        this.showTotal = { ...this.total }
      }
    },
    extractString (str) {
      const start = str.indexOf('other/') + 'other/'.length
      const end = str.indexOf('-exerland')

      if (start === -1 || end === -1) {
        return ''
      }
      return str.substring(start, end)
    },
    startPdf () {
      this.$refs.upText.click()
    },
    uploadFile (e) {
      this.$emit('uploadFile', e)
    },
    removePdf () {
      this.$emit('removeImg', this.index)
    }
  }
}
</script>

<style lang="scss" scoped>
.thumbnail {
  width: 150px;
  height: 120px;
  background-color: #f1f5f8;
  border-radius: 10px;
  padding-top: 2px;
  position: relative;
  text-align: center;
  .pdf {
    width: 100vw;
    height: 80vh;
  }
  .remove-img {
    position: absolute;
    right: 0;
    top: 0;
    width: 32px;
    height: 32px;
  }
  .add_icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  &_top {
    display: flex;
    justify-content: space-around;
    align-items: center;
    width: 144px;
    height: 60%;
    background-color: #fff;
    border-radius: 10px;
    margin: 0 auto;

    &_icon {
      width: 34px;
      height: 34px;
    }
  }

  &_bottom {
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    width: 144px;
    height: 40%;
    margin-top: 2px;
    align-items: center;
    margin: 0 auto;
    font-size: 14px;

    .pdf_name {
      display: -webkit-box;
      overflow: hidden;
      -webkit-line-clamp: 2; /* 控制显示的行数 */
      -webkit-box-orient: vertical;
      white-space: pre-line;
    }
    .thumbnail_bottom_icon {
      width: 16px;
    }
  }
}</style>
